import classcat from "classcat";
import React, { useCallback } from "react";

import { PreferenceOption } from "@is/types";

import css from "./AttributeOption.module.css";

type Props = {
  option: PreferenceOption;
  isSelected?: boolean;
  onOptionSelect: (option: PreferenceOption) => void;
};

const AttributeOption = ({ option, isSelected, onOptionSelect }: Props) => {
  const handleClick = useCallback(() => {
    onOptionSelect(option);
  }, [onOptionSelect, option]);

  return (
    <button
      className={classcat([
        css.container,
        "text-label-lg",
        { [css.selected]: isSelected },
      ])}
      onClick={handleClick}
    >
      {option.label}
    </button>
  );
};

export default AttributeOption;
